import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxMaskModule } from 'ngx-mask';
import { BarraConsultaAjudaComponent } from './barra-consulta-ajuda/barra-consulta-ajuda.component';
import { BarraConsultaExportServiceService } from './barra-consulta-export/barra-consulta-export-service.service';
import { BarraConsultaExportComponent } from './barra-consulta-export/barra-consulta-export.component';
import { BarraConsultaMensalComponent } from './barra-consulta-mensal/barra-consulta-mensal.component';
import { BarraConsultaMensalService } from './barra-consulta-mensal/barra-consulta-mensal.service';
import { BarraConsultaServiceService } from './barra-consulta/barra-consulta-service.service';
import { BarraConsultaComponent } from './barra-consulta/barra-consulta.component';
import { BarraCrudComponent } from './barra-crud/barra-crud.component';
import { BarraMenuComponent } from './barra-menu/barra-menu.component';
import { BarraMenuService } from './barra-menu/barra-menu.service';
import { BuscaCep } from './cep/busca-cep';
import { CheckBoxComponent } from './check-box/check-box.component';
import { ConversaoLibraConverte } from './conversao-libra/conversao-libra-converte';
import { DashBoard } from './dashboard';
import { FormatCurrencyDirective } from './directives/currency.directive';
import { SortDirective } from './directives/sort.directive';
import { DropdownListApiComponent } from './dropdown-list/dropdown-list-api.component';
import { DropdownListComponent } from './dropdown-list/dropdown-list.component';
import { ExportExcelService } from './excel-service/export-excel.service';
import { FileUploadModule } from './fileupload/fileupload';
import { FiltroDataComponent } from './filtro-data/filtro-data.component';
import { FiltroComponent } from './filtro/filtro.component';
import { FiltroService } from './filtro/filtro.service';
import { ColunaGridDirective } from './gridview/diretiva/coluna-grid.directive';
import { ConteudoColunaGridDirective } from './gridview/diretiva/conteudo-coluna-grid.directive';
import { ColunaCentralizadaComponent } from './gridview/estrutura/coluna-centralizada/coluna-centralizada.component';
import { ColunaGridBooleanComponent } from './gridview/estrutura/coluna-grid-boolean/coluna-grid-boolean.component';
import { ColunaGridNumericaFormatadaComponent } from './gridview/estrutura/coluna-grid-numerica-formatada/coluna-grid-numerica-formatada.component';
import { ColunaGridNumericaComponent } from './gridview/estrutura/coluna-grid-numerica/coluna-grid-numerica.component';
import { ColunaGridComponent } from './gridview/estrutura/coluna-grid/coluna-grid.component';
import { GridviewComponent } from './gridview/gridview.component';
import { InputContainerComponent } from './input-container/input-container.component';
import { JanelaComponent } from './janela/janela.component';
import { LoadingComponent } from './loading/loading.component';
import { NumeroFloatComponent } from './numero-float/numero-float.component';
import { Ng2OdometerComponent } from './odometer/odometer.component';
import { PrintPdfService } from './print-pdf/print-pdf.service';
import { SelecionarComponent } from './selecionar/selecionar.component';
import { TextBoxBuscaComponent } from './text-box-busca/text-box-busca.component';
import { TextBoxDataComponent } from './text-box-data/text-box-data.component';
import { TextBoxDataService } from './text-box-data/text-box-data.service';
import { TextBoxNoContainerComponent } from './text-box-no-container/text-box-no-container.component';
import { TextBoxPasswordComponent } from './text-box-password/text-box-password.component';
import { TextBoxComponent } from './text-box/text-box.component';
import { translateLoaderNBS } from './translate-loader/translateLoader';
import { TextBoxCurrencyComponent } from './text-box-currency/text-box-currency.component';
import { NgxCurrencyModule } from 'ngx-currency';
import { TextBoxLoginComponent } from './text-box-login/text-box-login.component';
import { FiltroDealersComponent } from './filtro-dealers/filtro-dealers.component';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';

registerLocaleData(localePt);

export function translateHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    NgbModule,
    HttpClientModule,
    BrowserModule,
    FormsModule,
    FileUploadModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    TranslateModule.forRoot(translateLoaderNBS),
    NgxCurrencyModule,
    DialogModule,
    TooltipModule
  ],
  exports: [
    FiltroComponent,
    FiltroDataComponent,
    NumeroFloatComponent,
    BarraMenuComponent,
    BarraConsultaComponent,
    BarraConsultaAjudaComponent,
    BarraConsultaExportComponent,
    BarraConsultaMensalComponent,
    BarraCrudComponent,
    GridviewComponent,
    TextBoxComponent,
    CheckBoxComponent,
    DropdownListComponent,
    DropdownListApiComponent,
    TextBoxBuscaComponent,
    TextBoxPasswordComponent,
    TextBoxNoContainerComponent,
    TextBoxDataComponent,
    TextBoxLoginComponent,
    LoadingComponent,
    SelecionarComponent,
    FormatCurrencyDirective,
    SortDirective,
    Ng2OdometerComponent,
    TextBoxCurrencyComponent,
    FiltroDealersComponent
  ],
  declarations: [
    FiltroComponent,
    FiltroDataComponent,
    NumeroFloatComponent,
    BarraMenuComponent,
    BarraConsultaComponent,
    BarraConsultaAjudaComponent,
    BarraConsultaExportComponent,
    BarraCrudComponent,
    GridviewComponent,
    ColunaGridDirective,
    ConteudoColunaGridDirective,
    ColunaGridComponent,
    ColunaGridBooleanComponent,
    ColunaGridNumericaComponent,
    ColunaGridNumericaFormatadaComponent,
    TextBoxComponent,
    CheckBoxComponent,
    InputContainerComponent,
    DropdownListComponent,
    DropdownListApiComponent,
    TextBoxBuscaComponent,
    TextBoxPasswordComponent,
    LoadingComponent,
    TextBoxDataComponent,
    JanelaComponent,
    SelecionarComponent,
    ColunaCentralizadaComponent,
    TextBoxNoContainerComponent,
    BarraConsultaMensalComponent,
    FormatCurrencyDirective,
    SortDirective,
    Ng2OdometerComponent,
    TextBoxCurrencyComponent,
    TextBoxLoginComponent,
    FiltroDealersComponent
  ],
  entryComponents: [
    ColunaGridComponent,
    ColunaGridBooleanComponent,
    ColunaGridNumericaComponent,
    ColunaGridNumericaFormatadaComponent,
    ColunaCentralizadaComponent,
    Ng2OdometerComponent
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: NgbDateParserFormatter, useClass: TextBoxDataService },
    FiltroService,
    BarraConsultaServiceService,
    BarraConsultaExportServiceService,
    BarraConsultaMensalService,
    BarraMenuService,
    DashBoard,
    BuscaCep,
    ConversaoLibraConverte,
    ExportExcelService,
    PrintPdfService
  ]
})
export class ComumModule { }
